<h2 mat-dialog-title>Edit Pyramid Item</h2>
<mat-dialog-content>
  <app-edit-pyramidal-pyramid-item
    [pyramidItem]="data.pyramidItem"
    [pyramidalShareholderId]="data.pyramidalShareholderId"
    [pyramidsByYear]="data.pyramidsByYear"
    [dialogRef]="dialogRef"
    (formValidityChanged)="onFormValidityChange($event)">
  </app-edit-pyramidal-pyramid-item>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" class="nrg-error-flat-button back-button" (click)="onCancel()">
    <mat-icon>clear</mat-icon>
    Cancel
  </button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="!isFormValid">
    <mat-icon>save</mat-icon>
    Update
  </button>
</mat-dialog-actions>
